import React from "react"
import PropTypes from "prop-types"

class OgConnection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ogConnections: []
    }

    this.imageSource = this.imageSource.bind(this)
    this.renderRequests = this.renderRequests.bind(this)
  }

  imageSource(src) {
    if(src === 'medium/missing.png') {
      return this.props.missingImg
    }
    return src
  }

  sendRequest(otherUserId) {
    data = {
      requestee_id: otherUserId
    }
    $.ajax({
      url: `../sendConnectRequest`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        // this.setState({
        //   ogConnections: this.state.
        // })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  componentDidMount() {
    $.ajax({
      url: `../getOgUserConnectData`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        if(data.data.og_connections != undefined && data.data.og_connections != "undefined") {
          this.setState({
            ogConnections: JSON.parse(data.data.og_connections),
          })
        }
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderRequests() {
    return this.state.ogConnections.map((connect, i) => {
      if ((this.props.ogConnectionsSent.includes(`${connect.preferred_name}`)) != true && (this.props.currentUserId != connect.id)) {
        return(
          <div className="connectionSection" key={i}>
            <div style={{width: 150, display: 'inline-block'}}>
                <button
                    style={{
                      alignItems: 'center',
                      cursor: 'pointer'
                    }}
                    onClick={() => window.location.assign(`/profile/${connect.slug}`)}
                    >
                    <img
                      src={connect.avatar_url === 'medium/missing.png' ? this.props.missingImg : this.imageSource(connect.avatar_url) }
                      style={{width: 100, height: 100, borderRadius: 5, boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}
                    />
                </button>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%'}}>
                <h4 className="sectionHeader">{connect.preferred_name}</h4>
                <h5 className="sectionText">You and {connect.preferred_name} previous chatted.</h5>
                <h5 className="sectionText">Send FREE Connect Request</h5>
                <h5 className="sectionText">before Jan 15.</h5>
                <div className="modalSingleButtonSection">
                  <button
                      className="smallPrimaryButton"
                      onClick={() => this.props.openRequest(connect.preferred_name, connect.id, true)}
                      >
                      Request to Connect
                  </button>
                </div>
            </div>
          </div>
        )
      }
    })
  }

  render() {
    if(this.state.ogConnections.length === 0) {
      return null
    }
    return(
      <div style={{maxWidth: 650}}>
        <h5 style={{color: '#FF595E', textAlign: 'center', fontWeight: '700', paddingTop: 30, paddingBottom: 10}}>Send by Jan 15!</h5>
        <h5 className="darkBlue" style={{fontWeight: 700}}>You have {this.state.ogConnections.length} member{this.state.ogConnections.length === 1 ? '' : 's'} you can Connect with for free.</h5>
        <h5 style={{fontWeight: '200'}} className="darkBlue">Before Lexicoins, Lexody used Chat Credits. You can opt-in to Connect with anyone you previously chatted with.<br />(If you decline, the other user will not know.)</h5>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        {this.state.ogConnections.length>0 && this.renderRequests()}
        </div>
      </div>
    )
  }
}

export default OgConnection;
